import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex justify-center py-16"
}
const _hoisted_2 = {
  key: 1,
  class: "text-center py-16"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", {
  class: "material-icons-outlined opacity-20 block mb-4",
  style: {"font-size":"4rem"}
}, "emoji_events", -1)
const _hoisted_4 = { class: "mb-2" }
const _hoisted_5 = { class: "text-muted mb-6" }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { class: "flex gap-1 mb-6 border-b border-gray-200" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  class: "material-icons-outlined mr-1 align-middle",
  style: {"font-size":"16px"}
}
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "flex justify-between items-center mb-4" }
const _hoisted_12 = { class: "mb-0" }
const _hoisted_13 = { class: "text-sm text-muted mt-0.5" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", {
  class: "material-icons-outlined mr-1",
  style: {"font-size":"16px"}
}, "add", -1)
const _hoisted_15 = {
  key: 0,
  class: "card card-border p-8 text-center text-muted"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", {
  class: "material-icons-outlined block mb-2 opacity-30",
  style: {"font-size":"2.5rem"}
}, "auto_awesome", -1)
const _hoisted_17 = {
  key: 1,
  class: "space-y-2"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons-outlined text-primary shrink-0 mt-0.5" }, "bolt", -1)
const _hoisted_19 = { class: "flex-1 min-w-0" }
const _hoisted_20 = { class: "font-medium text-sm leading-tight" }
const _hoisted_21 = { class: "text-xs text-muted font-mono mb-1" }
const _hoisted_22 = {
  key: 0,
  class: "flex flex-wrap gap-1"
}
const _hoisted_23 = {
  class: "material-icons",
  style: {"font-size":"11px"}
}
const _hoisted_24 = { class: "flex items-center gap-1 shrink-0 mt-0.5" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons text-yellow-400 text-sm" }, "auto_awesome", -1)
const _hoisted_26 = { class: "font-semibold text-sm" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { class: "text-xs text-muted ml-0.5" }, "pts", -1)
const _hoisted_28 = { class: "flex items-center gap-1 shrink-0 mt-0.5" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", {
  class: "material-icons-outlined",
  style: {"font-size":"16px"}
}, "edit", -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", {
  class: "material-icons-outlined",
  style: {"font-size":"16px"}
}, "delete", -1)
const _hoisted_31 = { key: 1 }
const _hoisted_32 = { class: "flex justify-between items-center mb-4" }
const _hoisted_33 = { class: "mb-0" }
const _hoisted_34 = { class: "text-sm text-muted mt-0.5" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("span", {
  class: "material-icons-outlined mr-1",
  style: {"font-size":"16px"}
}, "add", -1)
const _hoisted_36 = {
  key: 0,
  class: "card card-border p-8 text-center text-muted"
}
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", {
  class: "material-icons-outlined block mb-2 opacity-30",
  style: {"font-size":"2.5rem"}
}, "military_tech", -1)
const _hoisted_38 = {
  key: 1,
  class: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3"
}
const _hoisted_39 = { class: "w-10 h-10 rounded-full bg-primary-light flex items-center justify-center bg-opacity-20 shrink-0" }
const _hoisted_40 = {
  class: "material-icons text-primary",
  style: {"font-size":"20px"}
}
const _hoisted_41 = { class: "flex-1 min-w-0" }
const _hoisted_42 = { class: "font-medium leading-tight" }
const _hoisted_43 = { class: "text-xs text-muted mt-0.5 line-clamp-2" }
const _hoisted_44 = { class: "flex flex-col gap-1 shrink-0" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("span", {
  class: "material-icons-outlined",
  style: {"font-size":"14px"}
}, "edit", -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("span", {
  class: "material-icons-outlined",
  style: {"font-size":"14px"}
}, "delete", -1)
const _hoisted_47 = { key: 2 }
const _hoisted_48 = { class: "flex justify-between items-center mb-4" }
const _hoisted_49 = { class: "mb-0" }
const _hoisted_50 = { class: "text-sm text-muted mt-0.5" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("span", {
  class: "material-icons-outlined mr-1",
  style: {"font-size":"16px"}
}, "add", -1)
const _hoisted_52 = {
  key: 0,
  class: "card card-border p-8 text-center text-muted"
}
const _hoisted_53 = /*#__PURE__*/_createElementVNode("span", {
  class: "material-icons-outlined block mb-2 opacity-30",
  style: {"font-size":"2.5rem"}
}, "flag", -1)
const _hoisted_54 = {
  key: 1,
  class: "space-y-4"
}
const _hoisted_55 = { class: "flex items-center gap-3 px-4 py-3 bg-light" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons-outlined text-primary" }, "flag", -1)
const _hoisted_57 = { class: "font-semibold flex-1" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("span", {
  class: "material-icons-outlined",
  style: {"font-size":"16px"}
}, "edit", -1)
const _hoisted_59 = /*#__PURE__*/_createElementVNode("span", {
  class: "material-icons-outlined",
  style: {"font-size":"16px"}
}, "delete", -1)
const _hoisted_60 = /*#__PURE__*/_createElementVNode("span", {
  class: "material-icons-outlined mr-0.5",
  style: {"font-size":"14px"}
}, "add", -1)
const _hoisted_61 = {
  key: 0,
  class: "px-4 py-3 text-sm text-muted"
}
const _hoisted_62 = { key: 1 }
const _hoisted_63 = { class: "shrink-0 w-8 h-8 rounded-full bg-primary text-white flex items-center justify-center text-sm font-bold" }
const _hoisted_64 = { class: "flex-1 min-w-0" }
const _hoisted_65 = { class: "flex items-center gap-2 mb-1" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons text-yellow-400 text-sm" }, "auto_awesome", -1)
const _hoisted_67 = { class: "text-sm font-medium" }
const _hoisted_68 = {
  key: 0,
  class: "flex flex-wrap gap-1 mb-1"
}
const _hoisted_69 = /*#__PURE__*/_createElementVNode("span", {
  class: "material-icons-outlined",
  style: {"font-size":"12px"}
}, "bolt", -1)
const _hoisted_70 = {
  key: 1,
  class: "text-xs text-muted mb-1"
}
const _hoisted_71 = {
  key: 2,
  class: "flex flex-wrap gap-1"
}
const _hoisted_72 = {
  class: "material-icons",
  style: {"font-size":"11px"}
}
const _hoisted_73 = { class: "flex gap-1 shrink-0" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("span", {
  class: "material-icons-outlined",
  style: {"font-size":"14px"}
}, "edit", -1)
const _hoisted_75 = /*#__PURE__*/_createElementVNode("span", {
  class: "material-icons-outlined",
  style: {"font-size":"14px"}
}, "delete", -1)
const _hoisted_76 = { class: "space-y-4 py-2" }
const _hoisted_77 = { class: "block text-sm font-medium mb-1" }
const _hoisted_78 = ["disabled"]
const _hoisted_79 = {
  value: "",
  disabled: ""
}
const _hoisted_80 = ["value"]
const _hoisted_81 = { class: "block text-sm font-medium mb-1" }
const _hoisted_82 = { class: "text-xs text-muted mt-1" }
const _hoisted_83 = { key: 0 }
const _hoisted_84 = { class: "block text-sm font-medium mb-1" }
const _hoisted_85 = { class: "text-xs text-muted mb-2" }
const _hoisted_86 = { class: "flex flex-wrap gap-2" }
const _hoisted_87 = ["onClick"]
const _hoisted_88 = {
  class: "material-icons",
  style: {"font-size":"14px"}
}
const _hoisted_89 = {
  key: 0,
  class: "material-icons text-purple-500",
  style: {"font-size":"14px"}
}
const _hoisted_90 = { class: "space-y-4 py-2" }
const _hoisted_91 = { class: "block text-sm font-medium mb-1" }
const _hoisted_92 = ["placeholder"]
const _hoisted_93 = { class: "block text-sm font-medium mb-1" }
const _hoisted_94 = { class: "flex items-center gap-3" }
const _hoisted_95 = { class: "w-10 h-10 rounded-full bg-primary-light flex items-center justify-center bg-opacity-20" }
const _hoisted_96 = {
  class: "material-icons text-primary",
  style: {"font-size":"20px"}
}
const _hoisted_97 = { class: "text-xs text-muted mt-1" }
const _hoisted_98 = { class: "block text-sm font-medium mb-1" }
const _hoisted_99 = ["placeholder"]
const _hoisted_100 = { class: "py-2" }
const _hoisted_101 = { class: "block text-sm font-medium mb-1" }
const _hoisted_102 = ["placeholder"]
const _hoisted_103 = { class: "space-y-4 py-2" }
const _hoisted_104 = { class: "grid grid-cols-2 gap-4" }
const _hoisted_105 = { class: "block text-sm font-medium mb-1" }
const _hoisted_106 = { class: "block text-sm font-medium mb-1" }
const _hoisted_107 = { class: "flex items-center justify-between mb-2" }
const _hoisted_108 = { class: "block text-sm font-medium" }
const _hoisted_109 = /*#__PURE__*/_createElementVNode("span", {
  class: "material-icons-outlined mr-0.5",
  style: {"font-size":"14px"}
}, "add", -1)
const _hoisted_110 = { class: "text-xs text-muted mb-2" }
const _hoisted_111 = ["onUpdate:modelValue"]
const _hoisted_112 = {
  value: "",
  disabled: ""
}
const _hoisted_113 = ["value"]
const _hoisted_114 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted text-sm" }, "×", -1)
const _hoisted_115 = ["onUpdate:modelValue"]
const _hoisted_116 = /*#__PURE__*/_createElementVNode("span", {
  class: "material-icons-outlined",
  style: {"font-size":"14px"}
}, "close", -1)
const _hoisted_117 = {
  key: 0,
  class: "text-sm text-muted italic"
}
const _hoisted_118 = { key: 0 }
const _hoisted_119 = { class: "block text-sm font-medium mb-1" }
const _hoisted_120 = { class: "text-xs text-muted mb-2" }
const _hoisted_121 = { class: "flex flex-wrap gap-2" }
const _hoisted_122 = ["onClick"]
const _hoisted_123 = {
  class: "material-icons",
  style: {"font-size":"14px"}
}
const _hoisted_124 = {
  key: 0,
  class: "material-icons text-purple-500",
  style: {"font-size":"14px"}
}
const _hoisted_125 = {
  key: 0,
  class: "text-xs text-muted mt-1 italic"
}
const _hoisted_126 = { class: "py-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_Btn = _resolveComponent("Btn")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_Spinner)
        ]))
      : (!_ctx.contextId)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.$t("course_gamification.no_context_title")), 1),
            _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t("course_gamification.no_context_description")), 1),
            _createVNode(_component_Btn, {
              variant: "primary",
              loading: _ctx.creating,
              onClick: _ctx.setupContext
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("course_gamification.setup_button")), 1)
              ]),
              _: 1
            }, 8, ["loading", "onClick"])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: tab.key,
                  onClick: ($event: any) => (_ctx.activeTab = tab.key),
                  class: _normalizeClass(["px-4 py-2 text-sm font-medium border-b-2 transition-colors", 
						_ctx.activeTab === tab.key
							? 'border-primary text-primary'
							: 'border-transparent text-muted hover:text-gray-700'
					])
                }, [
                  _createElementVNode("span", _hoisted_9, _toDisplayString(tab.icon), 1),
                  _createTextVNode(" " + _toDisplayString(tab.label), 1)
                ], 10, _hoisted_8))
              }), 128))
            ]),
            (_ctx.activeTab === 'actions')
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", null, [
                      _createElementVNode("h2", _hoisted_12, _toDisplayString(_ctx.$t("course_gamification.actions_title")), 1),
                      _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$t("course_gamification.actions_description")), 1)
                    ]),
                    _createVNode(_component_Btn, {
                      variant: "primary",
                      size: "sm",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openActionDialog(null)))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_14,
                        _createTextVNode(" " + _toDisplayString(_ctx.$t("course_gamification.add_action")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  (_ctx.actions.length === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        _hoisted_16,
                        _createTextVNode(" " + _toDisplayString(_ctx.$t("course_gamification.no_actions")), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.actions, (act) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: act.id,
                            class: "card card-border px-4 py-3 flex items-start gap-4"
                          }, [
                            _hoisted_18,
                            _createElementVNode("div", _hoisted_19, [
                              _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.actionLabel(act.action_code)), 1),
                              _createElementVNode("p", _hoisted_21, _toDisplayString(act.action_code), 1),
                              (act.badges_awarded && act.badges_awarded.length)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(act.badges_awarded, (badgeId) => {
                                      return (_openBlock(), _createElementBlock("span", {
                                        key: badgeId,
                                        class: "inline-flex items-center gap-1 px-2 py-0.5 bg-purple-50 border border-purple-200 rounded-full text-xs text-purple-700"
                                      }, [
                                        _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.badgeById(badgeId)?.icon || "military_tech"), 1),
                                        _createTextVNode(" " + _toDisplayString(_ctx.badgeById(badgeId)?.name || badgeId), 1)
                                      ]))
                                    }), 128))
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_24, [
                              _hoisted_25,
                              _createElementVNode("span", _hoisted_26, _toDisplayString(act.reputation_awarded), 1),
                              _hoisted_27
                            ]),
                            _createElementVNode("div", _hoisted_28, [
                              _createVNode(_component_Btn, {
                                variant: "transparent",
                                size: "xs",
                                onClick: ($event: any) => (_ctx.openActionDialog(act))
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_29
                                ]),
                                _: 2
                              }, 1032, ["onClick"]),
                              _createVNode(_component_Btn, {
                                variant: "transparent",
                                size: "xs",
                                class: "text-danger",
                                onClick: ($event: any) => (_ctx.confirmDeleteAction(act))
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_30
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ])
                          ]))
                        }), 128))
                      ]))
                ]))
              : _createCommentVNode("", true),
            (_ctx.activeTab === 'badges')
              ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("div", null, [
                      _createElementVNode("h2", _hoisted_33, _toDisplayString(_ctx.$t("course_gamification.badges_title")), 1),
                      _createElementVNode("p", _hoisted_34, _toDisplayString(_ctx.$t("course_gamification.badges_description")), 1)
                    ]),
                    _createVNode(_component_Btn, {
                      variant: "primary",
                      size: "sm",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openBadgeDialog(null)))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_35,
                        _createTextVNode(" " + _toDisplayString(_ctx.$t("course_gamification.add_badge")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  (_ctx.badges.length === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                        _hoisted_37,
                        _createTextVNode(" " + _toDisplayString(_ctx.$t("course_gamification.no_badges")), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_38, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.badges, (badge) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: badge.id,
                            class: "card card-border p-4 flex items-start gap-3"
                          }, [
                            _createElementVNode("div", _hoisted_39, [
                              _createElementVNode("span", _hoisted_40, _toDisplayString(badge.icon || "military_tech"), 1)
                            ]),
                            _createElementVNode("div", _hoisted_41, [
                              _createElementVNode("p", _hoisted_42, _toDisplayString(badge.name), 1),
                              _createElementVNode("p", _hoisted_43, _toDisplayString(badge.description), 1)
                            ]),
                            _createElementVNode("div", _hoisted_44, [
                              _createVNode(_component_Btn, {
                                variant: "transparent",
                                size: "xs",
                                onClick: ($event: any) => (_ctx.openBadgeDialog(badge))
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_45
                                ]),
                                _: 2
                              }, 1032, ["onClick"]),
                              _createVNode(_component_Btn, {
                                variant: "transparent",
                                size: "xs",
                                class: "text-danger",
                                onClick: ($event: any) => (_ctx.confirmDeleteBadge(badge))
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_46
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ])
                          ]))
                        }), 128))
                      ]))
                ]))
              : _createCommentVNode("", true),
            (_ctx.activeTab === 'goals')
              ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                  _createElementVNode("div", _hoisted_48, [
                    _createElementVNode("div", null, [
                      _createElementVNode("h2", _hoisted_49, _toDisplayString(_ctx.$t("course_gamification.goals_title")), 1),
                      _createElementVNode("p", _hoisted_50, _toDisplayString(_ctx.$t("course_gamification.goals_description")), 1)
                    ]),
                    _createVNode(_component_Btn, {
                      variant: "primary",
                      size: "sm",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openGoalDialog(null)))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_51,
                        _createTextVNode(" " + _toDisplayString(_ctx.$t("course_gamification.add_goal")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  (_ctx.goals.length === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                        _hoisted_53,
                        _createTextVNode(" " + _toDisplayString(_ctx.$t("course_gamification.no_goals")), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_54, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.goals, (goal) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: goal.id,
                            class: "card card-border overflow-hidden"
                          }, [
                            _createElementVNode("div", _hoisted_55, [
                              _hoisted_56,
                              _createElementVNode("p", _hoisted_57, _toDisplayString(goal.name), 1),
                              _createVNode(_component_Btn, {
                                variant: "transparent",
                                size: "xs",
                                onClick: ($event: any) => (_ctx.openGoalDialog(goal))
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_58
                                ]),
                                _: 2
                              }, 1032, ["onClick"]),
                              _createVNode(_component_Btn, {
                                variant: "transparent",
                                size: "xs",
                                class: "text-danger",
                                onClick: ($event: any) => (_ctx.confirmDeleteGoal(goal))
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_59
                                ]),
                                _: 2
                              }, 1032, ["onClick"]),
                              _createVNode(_component_Btn, {
                                variant: "secondary",
                                size: "xs",
                                onClick: ($event: any) => (_ctx.openLevelDialog(goal, null))
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_60,
                                  _createTextVNode(" " + _toDisplayString(_ctx.$t("course_gamification.add_level")), 1)
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ]),
                            (!goal.levels || goal.levels.length === 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_61, _toDisplayString(_ctx.$t("course_gamification.no_levels")), 1))
                              : (_openBlock(), _createElementBlock("div", _hoisted_62, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedLevels(goal), (level) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: level.id,
                                      class: "flex items-start gap-4 px-4 py-3 border-t border-gray-100"
                                    }, [
                                      _createElementVNode("div", _hoisted_63, _toDisplayString(level.level_value), 1),
                                      _createElementVNode("div", _hoisted_64, [
                                        _createElementVNode("div", _hoisted_65, [
                                          _hoisted_66,
                                          _createElementVNode("span", _hoisted_67, _toDisplayString(level.reputation_awarded) + " pts", 1)
                                        ]),
                                        (level.requirements && level.requirements.length)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(level.requirements, (req) => {
                                                return (_openBlock(), _createElementBlock("span", {
                                                  key: req.id || req.action_definition_id,
                                                  class: "inline-flex items-center gap-1 px-2 py-0.5 bg-gray-100 rounded text-xs text-gray-700"
                                                }, [
                                                  _hoisted_69,
                                                  _createTextVNode(" " + _toDisplayString(_ctx.actionLabel(req.action_code || "")) + " × " + _toDisplayString(req.amount), 1)
                                                ]))
                                              }), 128))
                                            ]))
                                          : (_openBlock(), _createElementBlock("p", _hoisted_70, _toDisplayString(_ctx.$t("course_gamification.no_requirements")), 1)),
                                        (level.badges_awarded && level.badges_awarded.length)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(level.badges_awarded, (badgeId) => {
                                                return (_openBlock(), _createElementBlock("span", {
                                                  key: badgeId,
                                                  class: "inline-flex items-center gap-1 px-2 py-0.5 bg-purple-50 border border-purple-200 rounded-full text-xs text-purple-700"
                                                }, [
                                                  _createElementVNode("span", _hoisted_72, _toDisplayString(_ctx.badgeById(badgeId)?.icon || "military_tech"), 1),
                                                  _createTextVNode(" " + _toDisplayString(_ctx.badgeById(badgeId)?.name || badgeId), 1)
                                                ]))
                                              }), 128))
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _createElementVNode("div", _hoisted_73, [
                                        _createVNode(_component_Btn, {
                                          variant: "transparent",
                                          size: "xs",
                                          onClick: ($event: any) => (_ctx.openLevelDialog(goal, level))
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_74
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"]),
                                        _createVNode(_component_Btn, {
                                          variant: "transparent",
                                          size: "xs",
                                          class: "text-danger",
                                          onClick: ($event: any) => (_ctx.confirmDeleteLevel(goal, level))
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_75
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"])
                                      ])
                                    ]))
                                  }), 128))
                                ]))
                          ]))
                        }), 128))
                      ]))
                ]))
              : _createCommentVNode("", true)
          ])),
    _createVNode(_component_Dialog, {
      showDialog: _ctx.showActionDialog,
      yesText: _ctx.$t('misc.save'),
      disableOk: !_ctx.actionForm.action_code,
      loading: _ctx.saving,
      onYes: _ctx.saveAction,
      onNo: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showActionDialog = false))
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.editingAction
						? _ctx.$t("course_gamification.edit_action")
						: _ctx.$t("course_gamification.add_action")), 1)
      ]),
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_76, [
          _createElementVNode("div", null, [
            _createElementVNode("label", _hoisted_77, _toDisplayString(_ctx.$t("course_gamification.action_type")), 1),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.actionForm.action_code) = $event)),
              disabled: !!_ctx.editingAction,
              class: "w-full border border-gray-300 rounded px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-primary"
            }, [
              _createElementVNode("option", _hoisted_79, _toDisplayString(_ctx.$t("course_gamification.select_action")), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableActionsForForm, (va) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: va.code,
                  value: va.code
                }, _toDisplayString(va.label), 9, _hoisted_80))
              }), 128))
            ], 8, _hoisted_78), [
              [_vModelSelect, _ctx.actionForm.action_code]
            ])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("label", _hoisted_81, _toDisplayString(_ctx.$t("course_gamification.points_awarded")), 1),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.actionForm.reputation_awarded) = $event)),
              type: "number",
              min: "0",
              class: "w-full border border-gray-300 rounded px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-primary"
            }, null, 512), [
              [
                _vModelText,
                _ctx.actionForm.reputation_awarded,
                void 0,
                { number: true }
              ]
            ]),
            _createElementVNode("p", _hoisted_82, _toDisplayString(_ctx.$t("course_gamification.points_hint")), 1)
          ]),
          (_ctx.badges.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                _createElementVNode("label", _hoisted_84, _toDisplayString(_ctx.$t("course_gamification.action_badges_awarded")), 1),
                _createElementVNode("p", _hoisted_85, _toDisplayString(_ctx.$t("course_gamification.action_badges_hint")), 1),
                _createElementVNode("div", _hoisted_86, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.badges, (badge) => {
                    return (_openBlock(), _createElementBlock("button", {
                      key: badge.id,
                      type: "button",
                      onClick: ($event: any) => (_ctx.toggleBadge(_ctx.actionForm.badges_awarded, badge.id)),
                      class: _normalizeClass(["inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full border text-sm transition-colors", 
									_ctx.actionForm.badges_awarded.includes(badge.id)
										? 'bg-purple-100 border-purple-400 text-purple-800'
										: 'bg-white border-gray-300 text-gray-600 hover:border-gray-400'
								])
                    }, [
                      _createElementVNode("span", _hoisted_88, _toDisplayString(badge.icon || "military_tech"), 1),
                      _createTextVNode(" " + _toDisplayString(badge.name) + " ", 1),
                      (_ctx.actionForm.badges_awarded.includes(badge.id))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_89, "check"))
                        : _createCommentVNode("", true)
                    ], 10, _hoisted_87))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["showDialog", "yesText", "disableOk", "loading", "onYes"]),
    _createVNode(_component_Dialog, {
      showDialog: _ctx.showBadgeDialog,
      yesText: _ctx.$t('misc.save'),
      disableOk: !_ctx.badgeForm.name,
      loading: _ctx.saving,
      onYes: _ctx.saveBadge,
      onNo: _cache[9] || (_cache[9] = ($event: any) => (_ctx.showBadgeDialog = false))
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.editingBadge
						? _ctx.$t("course_gamification.edit_badge")
						: _ctx.$t("course_gamification.add_badge")), 1)
      ]),
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_90, [
          _createElementVNode("div", null, [
            _createElementVNode("label", _hoisted_91, _toDisplayString(_ctx.$t("course_gamification.badge_name")), 1),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.badgeForm.name) = $event)),
              type: "text",
              class: "w-full border border-gray-300 rounded px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-primary",
              placeholder: _ctx.$t('course_gamification.badge_name_placeholder')
            }, null, 8, _hoisted_92), [
              [_vModelText, _ctx.badgeForm.name]
            ])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("label", _hoisted_93, _toDisplayString(_ctx.$t("course_gamification.badge_icon")), 1),
            _createElementVNode("div", _hoisted_94, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.badgeForm.icon) = $event)),
                type: "text",
                class: "flex-1 border border-gray-300 rounded px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-primary",
                placeholder: "military_tech"
              }, null, 512), [
                [_vModelText, _ctx.badgeForm.icon]
              ]),
              _createElementVNode("div", _hoisted_95, [
                _createElementVNode("span", _hoisted_96, _toDisplayString(_ctx.badgeForm.icon || "military_tech"), 1)
              ])
            ]),
            _createElementVNode("p", _hoisted_97, _toDisplayString(_ctx.$t("course_gamification.badge_icon_hint")), 1)
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("label", _hoisted_98, _toDisplayString(_ctx.$t("course_gamification.badge_description")), 1),
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.badgeForm.description) = $event)),
              rows: "2",
              class: "w-full border border-gray-300 rounded px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-primary",
              placeholder: _ctx.$t('course_gamification.badge_description_placeholder')
            }, null, 8, _hoisted_99), [
              [_vModelText, _ctx.badgeForm.description]
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["showDialog", "yesText", "disableOk", "loading", "onYes"]),
    _createVNode(_component_Dialog, {
      showDialog: _ctx.showGoalDialog,
      yesText: _ctx.$t('misc.save'),
      disableOk: !_ctx.goalForm.name,
      loading: _ctx.saving,
      onYes: _ctx.saveGoal,
      onNo: _cache[11] || (_cache[11] = ($event: any) => (_ctx.showGoalDialog = false))
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.editingGoal
						? _ctx.$t("course_gamification.edit_goal")
						: _ctx.$t("course_gamification.add_goal")), 1)
      ]),
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_100, [
          _createElementVNode("label", _hoisted_101, _toDisplayString(_ctx.$t("course_gamification.goal_name")), 1),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.goalForm.name) = $event)),
            type: "text",
            class: "w-full border border-gray-300 rounded px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-primary",
            placeholder: _ctx.$t('course_gamification.goal_name_placeholder')
          }, null, 8, _hoisted_102), [
            [_vModelText, _ctx.goalForm.name]
          ])
        ])
      ]),
      _: 1
    }, 8, ["showDialog", "yesText", "disableOk", "loading", "onYes"]),
    _createVNode(_component_Dialog, {
      showDialog: _ctx.showLevelDialog,
      yesText: _ctx.$t('misc.save'),
      loading: _ctx.saving,
      onYes: _ctx.saveLevel,
      onNo: _cache[14] || (_cache[14] = ($event: any) => (_ctx.showLevelDialog = false))
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.editingLevel
						? _ctx.$t("course_gamification.edit_level")
						: _ctx.$t("course_gamification.add_level")), 1)
      ]),
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_103, [
          _createElementVNode("div", _hoisted_104, [
            _createElementVNode("div", null, [
              _createElementVNode("label", _hoisted_105, _toDisplayString(_ctx.$t("course_gamification.level_number")), 1),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.levelForm.level_value) = $event)),
                type: "number",
                min: "1",
                class: "w-full border border-gray-300 rounded px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-primary"
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.levelForm.level_value,
                  void 0,
                  { number: true }
                ]
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("label", _hoisted_106, _toDisplayString(_ctx.$t("course_gamification.points_awarded")), 1),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.levelForm.reputation_awarded) = $event)),
                type: "number",
                min: "0",
                class: "w-full border border-gray-300 rounded px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-primary"
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.levelForm.reputation_awarded,
                  void 0,
                  { number: true }
                ]
              ])
            ])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_107, [
              _createElementVNode("label", _hoisted_108, _toDisplayString(_ctx.$t("course_gamification.level_requirements")), 1),
              _createVNode(_component_Btn, {
                variant: "transparent",
                size: "xs",
                onClick: _ctx.addRequirement
              }, {
                default: _withCtx(() => [
                  _hoisted_109,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("course_gamification.add_requirement")), 1)
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _createElementVNode("p", _hoisted_110, _toDisplayString(_ctx.$t("course_gamification.requirements_hint")), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.levelForm.requirements, (req, i) => {
              return (_openBlock(), _createElementBlock("div", {
                key: i,
                class: "flex items-center gap-2 mb-2"
              }, [
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": ($event: any) => ((req.action_definition_id) = $event),
                  class: "flex-1 border border-gray-300 rounded px-2 py-1.5 text-sm focus:outline-none focus:ring-1 focus:ring-primary"
                }, [
                  _createElementVNode("option", _hoisted_112, _toDisplayString(_ctx.$t("course_gamification.select_action")), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.actions, (act) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: act.id,
                      value: act.id
                    }, _toDisplayString(_ctx.actionLabel(act.action_code)), 9, _hoisted_113))
                  }), 128))
                ], 8, _hoisted_111), [
                  [_vModelSelect, req.action_definition_id]
                ]),
                _hoisted_114,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": ($event: any) => ((req.amount) = $event),
                  type: "number",
                  min: "1",
                  class: "w-16 border border-gray-300 rounded px-2 py-1.5 text-sm focus:outline-none focus:ring-1 focus:ring-primary"
                }, null, 8, _hoisted_115), [
                  [
                    _vModelText,
                    req.amount,
                    void 0,
                    { number: true }
                  ]
                ]),
                _createVNode(_component_Btn, {
                  variant: "transparent",
                  size: "xs",
                  class: "text-danger",
                  onClick: ($event: any) => (_ctx.removeRequirement(i))
                }, {
                  default: _withCtx(() => [
                    _hoisted_116
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]))
            }), 128)),
            (_ctx.levelForm.requirements.length === 0)
              ? (_openBlock(), _createElementBlock("p", _hoisted_117, _toDisplayString(_ctx.$t("course_gamification.no_requirements_set")), 1))
              : _createCommentVNode("", true)
          ]),
          (_ctx.badges.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_118, [
                _createElementVNode("label", _hoisted_119, _toDisplayString(_ctx.$t("course_gamification.level_badges_awarded")), 1),
                _createElementVNode("p", _hoisted_120, _toDisplayString(_ctx.$t("course_gamification.level_badges_hint")), 1),
                _createElementVNode("div", _hoisted_121, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.badges, (badge) => {
                    return (_openBlock(), _createElementBlock("button", {
                      key: badge.id,
                      type: "button",
                      onClick: ($event: any) => (_ctx.toggleBadge(_ctx.levelForm.badges_awarded, badge.id)),
                      class: _normalizeClass(["inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full border text-sm transition-colors", 
									_ctx.levelForm.badges_awarded.includes(badge.id)
										? 'bg-purple-100 border-purple-400 text-purple-800'
										: 'bg-white border-gray-300 text-gray-600 hover:border-gray-400'
								])
                    }, [
                      _createElementVNode("span", _hoisted_123, _toDisplayString(badge.icon || "military_tech"), 1),
                      _createTextVNode(" " + _toDisplayString(badge.name) + " ", 1),
                      (_ctx.levelForm.badges_awarded.includes(badge.id))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_124, "check"))
                        : _createCommentVNode("", true)
                    ], 10, _hoisted_122))
                  }), 128))
                ]),
                (!_ctx.levelForm.badges_awarded.length)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_125, _toDisplayString(_ctx.$t("course_gamification.no_badges_selected")), 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["showDialog", "yesText", "loading", "onYes"]),
    _createVNode(_component_Dialog, {
      showDialog: _ctx.showDeleteDialog,
      yesText: _ctx.$t('misc.delete'),
      loading: _ctx.deleting,
      onYes: _ctx.performDelete,
      onNo: _cache[15] || (_cache[15] = ($event: any) => (_ctx.showDeleteDialog = false))
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t("misc.confirm_delete")), 1)
      ]),
      body: _withCtx(() => [
        _createElementVNode("p", _hoisted_126, _toDisplayString(_ctx.deleteMessage), 1)
      ]),
      _: 1
    }, 8, ["showDialog", "yesText", "loading", "onYes"])
  ]))
}